import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

/**
 * サーバ時間取得API
 */
export namespace ApiTaCm020 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {}

    // API Response
    export interface Response {
      serverDate: string // yyyy/MM/dd
      serverTime: string // hh:mm:ss
      serverDateAndTime: string // yyyy-MM-ddThh:mm:ss+hh:MM
    }
  }

  // API Path
  export const path: string = '/ta/serverTimes'

  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, undefined> {
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<undefined, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        serverDate: '',
        serverTime: '',
        serverDateAndTime: '',
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, undefined, R>(
        api.get<Get.Response>(path, params),
        successHandler,
        errorHandler,
        validationSample,
        undefined
      )
    }
  }
}
